export const not_options = {
    position: ['bottom', 'left'],
    timeOut: 10000,
    showProgressBar: true,
    pauseOnHover: false,
    clickToClose: true
};
